import { Tabs, TabsProps } from "antd";
import React, { FC } from "react";
import { Questionnaire } from "../Questionnaire/Questionnaire";
import { Founders } from "../Founders/Founders";
import { Finance } from "../Finance/Finance";
import { Scoring } from "../Scoring/Scoring";
import { ApplicationDetailsDoсList } from "../ApplicationDetailsDoсList/ApplicationDetailsDoсList";
import { Offer } from "../Offer/Offer";
import { ProfessionalJudgment } from "../ProfessionalJudgment/ProfessionalJudgment";
import { BankGuaranteeIssuance } from "../BankGuaranteeIssuance/BankGuaranteeIssuance";
import { APPLICATION_BANK_STATUS } from "../../../../utils/guards/ApplicationBankStatusGuard/types";
import { useParams } from "react-router-dom";
import { useGetApplicationDataToBankQuery } from "../../../../store/api/applicationBankApi/applicationBank.api";
import { ApplicationHistory } from "../ApplicationHistory/ApplicationHistory";

const items = (
  applicationBankStatus?: APPLICATION_BANK_STATUS
): TabsProps["items"] => {
  return [
    {
      key: "1",
      label: "Анкета",
      children: <Questionnaire />,
    },
    {
      key: "2",
      label: "ЕИО и учредители",
      children: <Founders />,
    },
    {
      key: "3",
      label: "Финансы",
      children: <Finance />,
    },
    {
      key: "4",
      label: "Документы",
      children: <ApplicationDetailsDoсList />,
    },
    {
      key: "5",
      label: "Скоринг",
      children: <Scoring />,
    },
    {
      key: "6",
      label: "Предложение",
      children: <Offer />,
      disabled:
        applicationBankStatus === "new_application" ||
        applicationBankStatus === "directed" ||
        applicationBankStatus === "revision",
    },
    {
      key: "7",
      label: "Профсуждение",
      children: <ProfessionalJudgment />,
      disabled:
        applicationBankStatus === "new_application" ||
        applicationBankStatus === "directed" ||
        applicationBankStatus === "revision",
    },
    {
      key: "8",
      label: "Выдача БГ",
      children: <BankGuaranteeIssuance />,
      disabled:
        applicationBankStatus !== "signed_manager" &&
        applicationBankStatus !== "deal_completed", // поправить
    },
    {
      key: "9",
      label: "История",
      children: <ApplicationHistory />,
      // disabled: false, // поправить
    },
  ];
};

export const ApplicationTabs: FC = () => {
  const { applicationBankId } = useParams();

  const { data: applicationBank } = useGetApplicationDataToBankQuery(
    Number(applicationBankId)
  );

  return (
    <Tabs
      destroyInactiveTabPane={true}
      style={{ marginTop: "32px" }}
      defaultActiveKey="1"
      items={items(applicationBank?.modified_bank_status.type)}
      type="card"
    />
  );
};
